import i18next from "i18next";
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function breakWordsOnCaseChange(string) {
    return string.replace(/([A-Z])/g, " $1").trim();
}

export function prettifyString(string) {
    let word = i18next.t("Filtering." + string);

    if (word && word.length > 0) {
        return word;
    }

    const brokenString = breakWordsOnCaseChange(string);
    return capitalizeFirstLetter(brokenString);
}
